import { render, staticRenderFns } from "./OFilesTable.vue?vue&type=template&id=38bf6cc2&"
import script from "./OFilesTable.vue?vue&type=script&lang=js&"
export * from "./OFilesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports